import React, { useState } from 'react';
import { Share2, XCircle } from 'lucide-react';

interface ThankYouPageProps {
  resultUrl: string;
}

const ThankYouPage: React.FC<ThankYouPageProps> = ({ resultUrl }) => {
  const [showError, setShowError] = useState<boolean>(true);
  
  const handleCopyUrl = () => {
    navigator.clipboard.writeText(resultUrl)
      .then(() => {
        alert('URL copied to clipboard!');
      })
      .catch((err) => {
        console.error('Could not copy URL: ', err);
      });
  };
  
  return (
    <div className="text-center flex flex-col items-center p-6 bg-white dark:bg-gray-900 rounded-xl shadow-lg max-w-2xl mx-auto">
      <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-indigo-600 to-red-500 text-transparent bg-clip-text">
        Thank you for your contribution.
      </h2>
      <p className="text-xl mb-6 text-gray-700 dark:text-gray-300">Your pain, in particular, pleases me. I wish I could manifest it into a soothing balm for my weary soul.</p>
      <p className="text-2xl italic font-serif mb-8 text-gray-800 dark:text-gray-200">- Dr. Matt</p>
      
      <div className="w-full max-w-md mt-8 border-t border-gray-300 dark:border-gray-700 pt-6 text-left">
        <p className="mb-2 text-gray-800 dark:text-gray-200">Your result URL:</p>
        <div className="flex border rounded overflow-hidden mb-6">
          <input 
            type="text" 
            value={resultUrl} 
            readOnly 
            className="flex-1 p-2 text-sm bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200" 
          />
          <button
            className="bg-gray-100 dark:bg-gray-800 px-3 text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700"
            onClick={handleCopyUrl}
          >
            Copy
          </button>
        </div>
        
        <div className="flex space-x-4">
          <a
            href={resultUrl}
            className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white p-3 rounded flex items-center justify-center gap-2"
          >
            <Share2 size={18} />
            Share Results
          </a>
          <a
            href={resultUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200 p-3 rounded border border-gray-300 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center justify-center"
          >
            View Results
          </a>
        </div>
      </div>
      
      {/* Error Module */}
      {showError && (
        <div className="w-full max-w-md mt-8 border border-red-500 rounded-lg overflow-hidden">
          <div className="bg-red-500 text-white px-4 py-2 flex justify-between items-center">
            <h3 className="m-0 text-sm font-medium">Error</h3>
            <button 
              className="bg-transparent border-0 text-white flex items-center justify-center"
              onClick={() => setShowError(false)}
            >
              <XCircle size={16} />
            </button>
          </div>
          <div className="p-4 text-red-600 dark:text-red-400 bg-red-50 dark:bg-gray-800">
            <p className="m-0">Sorry, there is no help coming.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ThankYouPage;